 
export const WEBSITES_SELECTION_TOP_N_VALUES: readonly number[] = [50, 100, 250, 500, 1_000];
export const WEBSITES_SAVE_TO_LIST_SELECTION_TOP_N_VALUES: readonly number[] =
     
    WEBSITES_SELECTION_TOP_N_VALUES.concat(5_000);
